import { Copy, RefreshCw, Target } from 'lucide-react';
import React from 'react';

const SimulationResults = ({ simulateBet, loading, errors, results, authTokens, getStepIcon }) => {
  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
  };

  return (
    <div className="mb-6">
      {/* Кнопка запуску симуляції */}
      <div className="mb-6">
        <button
          onClick={simulateBet}
          disabled={loading.simulate || !authTokens.sessionId}
          className="flex items-center justify-center w-full gap-2 px-6 py-3 font-semibold text-white transition-colors bg-green-600 rounded-lg hover:bg-green-700 disabled:bg-green-400"
        >
          {loading.simulate ? <RefreshCw className="w-5 h-5 animate-spin" /> : <Target className="w-5 h-5" />}
          {loading.simulate ? 'Запуск симуляції...' : 'Запустити симуляцію ставок'}
        </button>
      </div>

      {/* Результат симуляції */}
      <div className="p-4 bg-white border border-gray-200 rounded-lg">
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-3">
            {getStepIcon('simulate')}
            <Target className="w-5 h-5 text-gray-600" />
            <h3 className="text-lg font-semibold text-gray-900">Результат симуляції</h3>
          </div>
          {results.simulate && (
            <button
              onClick={() => copyToClipboard(JSON.stringify(results.simulate, null, 2))}
              className="flex items-center gap-1 px-3 py-1 text-sm font-medium text-blue-700 bg-blue-100 rounded hover:bg-blue-200"
              title="Копіювати результат"
            >
              <Copy className="w-4 h-4" />
              Копіювати
            </button>
          )}
        </div>

        {errors.simulate && <div className="p-2 mb-3 text-sm text-red-600 rounded bg-red-50">{errors.simulate}</div>}

        {results.simulate && (
          <div>
            <div className="p-2 mb-3 text-sm text-green-600 rounded bg-green-50">Симуляція виконана успішно!</div>
            <details>
              <summary className="text-sm text-gray-600 cursor-pointer">Показати детальні результати</summary>
              <pre className="p-2 mt-2 overflow-x-auto text-xs bg-gray-100 rounded max-h-96">
                {JSON.stringify(results.simulate, null, 2)}
              </pre>
            </details>
          </div>
        )}

        {!results.simulate && !errors.simulate && !loading.simulate && (
          <p className="text-sm text-gray-500">Результати з'являться після запуску симуляції</p>
        )}
      </div>
    </div>
  );
};

export default SimulationResults;
